module.exports = __webpack_public_path__ + "media/fuse.bd9fc8a8.webm";